export default __webpack_public_path__ + "static/man-using-app-d67553f85cde4d533675b7534857f6a6.png";